module.exports = __webpack_public_path__ + "img/xwzx_xwzx_1920337.5@1x-tuya.b88334f9.png";